import {useDispatch, useSelector} from "react-redux";
import {notification, Tabs} from "antd";
import {useEffect, useState} from "react";
import {Button, Icon, Loading} from "../../../components";
import {TicketTable} from "../components";
import {
    ticketActions,
    ticketErrorSelector, ticketFilterSelector,
    ticketItemsSelector,
    ticketLoadingSelector,
    ticketPaginationSelector
} from "../TicketSlice";
import ActionBar from "../../../layout/ActionBar";
import {useParams} from "react-router-dom";
import {apiError, handleRequest} from "../../../utils";
import {ticketApi} from "../../../api";
import {forEach} from "lodash";
import {globalNavigate} from "../../../routes/GlobalHistory";


function Ticket()
{
    const {status} = useParams();

    const dispatch = useDispatch();

    const items = useSelector(ticketItemsSelector)

    const loading = useSelector(ticketLoadingSelector)

    const error = useSelector(ticketErrorSelector)

    const pagination = useSelector(ticketPaginationSelector)

    const filter = useSelector(ticketFilterSelector)

    const [tabs, setTabs] = useState([
        {
            key: '',
            label: 'Tất cả',
        }
    ]);

    const eventsHandler = {
        load: () =>
        {
            dispatch(ticketActions.fetchData({
                ...filter,
                detail:['customer']
            }))
        },
        loadTabs: async () =>
        {
            let [error, response] = await handleRequest(ticketApi.statusTab({
                type: 'ticket'
            }));

            let message = apiError(`Load danh sách tab trạng thái`, error, response);

            if (!message)
            {
                let tabsTemp = [{
                    key: '',
                    label: `Tất cả (${response.data.total})`,
                }]

                forEach(response.data.tabs, function (tab) {
                    tabsTemp.push({
                        key: tab.value,
                        label: tab.label + ' (' + tab.count + ')',
                    })
                })

                setTabs(tabsTemp)
            }
        },
        changePagination: (page) =>
        {
            dispatch(ticketActions.setFilter(...filter, page))
        },
        changeTab: (tab) =>
        {
            globalNavigate(`/ticket/${tab}`);
        },
        reload: () =>
        {
            eventsHandler.loadTabs()
            eventsHandler.load()
        }
    }

    useEffect(() => {
        eventsHandler.loadTabs().then()
    }, [])

    useEffect(() => {
        if(status !== filter.status) {
            dispatch(ticketActions.setFilter({
                ...filter,
                status: status,
                page: 1
            }))
        }
    }, [status]);

    useEffect(() => {
        eventsHandler.load()
    }, [filter])

    if(error)
    {
        notification.error({
            message: 'Có lỗi xảy ra',
            description: error,
        })
    }

    return (
        <>
            <ActionBar title={'Ticket'}>
                <Button outline small onClick={eventsHandler.reload} style={{fontSize:'20px'}}>{Icon.reload}</Button>
            </ActionBar>
            <div className="container">
                <div className="content">
                    {loading && <Loading />}
                    <div className="pd-1">
                        <Tabs
                            defaultActiveKey={status}
                            items={tabs}
                            onChange={eventsHandler.changeTab}
                        />
                    </div>
                    {items && <TicketTable
                        items={items}
                        pagination={pagination}
                        onPaginationChange={eventsHandler.changePagination}
                    />}
                </div>
            </div>
        </>

    )
}

export default Ticket;